module.exports = __webpack_public_path__ + "img/key.60578e4c.png";